export default {"src":"/_next/static/media/FullText.e942b6d7.svg","height":15,"width":13,"blurWidth":0,"blurHeight":0};